export class AuthConfig {
    checkPhoneAndSendPin: string;
    login: string;
    register: string;
    forgotPassword: string;
    refresh: string;
    logout: string;
    loginAfterReset: string;
    loginSendResetCode: string;
    addByPhone: string;
}
